import { RoutePaths } from '../../constants';

export function getUserProfileLink(login: string) {
    return `${RoutePaths.UserProfile}/${login}`;
}
